import { Component, OnInit, OnDestroy, Directive, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';

import { AppConstants } from 'appshared/app-constants';
import * as Models from 'appshared/shared-models';
import { MiscTools } from 'appshared/misc-tools';
import { TextTools } from 'appshared/text-tools';
import { UITools } from 'appshared/ui-tools';
import { ValidationTools } from 'appshared/validation-tools';

import { ZenCustomersService } from '../zen-customers.service';
import { OrganizationsService } from '../../organizations/organizations.service';
import { UsersService } from '../../users/users.service';
import { ProductsService } from '../../products/products.service';

import { TableZenUsersComponent } from 'client/app/components/shared/table-zen-users/table-zen-users.component';

@Component({
	selector: 'app-zen-customers-report-users',
	templateUrl: './zen-customers-report-users.component.html',
	styleUrls: ['./zen-customers-report-users.component.scss']
})
export class ZenCustomersReportUsersComponent implements OnInit {
	ac = AppConstants;
	vt = ValidationTools;
	tt = TextTools;
	mt = MiscTools;
	ut = UITools;

	@ViewChild(TableZenUsersComponent) zenUsersTable: TableZenUsersComponent = null;

	items: Models.ZenMasterUser[] = [];
	itemsToShow: Models.ZenMasterUser[] = [];

	zenCustomers: Models.ZenMasterCustomer[] = [];
	users: Models.User[] = [];
	storageKey: string = 'WIPE-FILTER.cp-zen-users-report';

	loading = true;

	constructor(
		private router: Router,
		private usersService: UsersService,
		private productsService: ProductsService,
		private organizationsService: OrganizationsService,
		private zenCustomersService: ZenCustomersService) { }

	// ------------------------------------------------------------------------
	ngOnInit(): void {
		this.loadZenObjects();
	}

	// ------------------------------------------------------------------------
	async loadZenObjects(forceReload = false) {
		this.loading = true;
		this.users = this.usersService.getAll();
		this.zenCustomers = this.zenCustomersService.getAll();

		const allProducts = this.productsService.getAll();
		let zenID = -1;
		for (const prod of allProducts)
			if (prod.name === 'ZEN Master')
				zenID = prod.id;

		let zenOrgIDs: number[] = [];
		if (zenID !== -1) {
			const allOrgs = this.organizationsService.getAll();
			for (const org of allOrgs)
				if (MiscTools.findIndexGeneric(org.product_platforms, 'product_id', zenID) !== -1)
					zenOrgIDs.push(org.id);
		} // if

		this.items = await this.zenCustomersService.getZenUsers();
		for (const item of this.items) {
			const idx = MiscTools.findIndexGeneric(this.zenCustomers, 'id', item.customer_id);
			// if (idx !== -1)
			// 	user.zen_customer = this.zenCustomers[idx];

			item['__zenPrefix'] = this.zenCustomers[idx].dns_prefix;
			item['__zenEnabled'] = this.zenCustomers[idx].is_enabled;
			item['__zenType'] = this.zenCustomers[idx].zcp_type;

			item['__sinceAdd'] = null;
			if (item.created_at) item['__sinceAdd'] = MiscTools.daysSince(item.created_at, true);

			item['__sinceLogin'] = null;
			if (item.last_login_at) item['__sinceLogin'] = MiscTools.daysSince(item.last_login_at, true);

			item['__noOrgUser'] = false;
			item['__diffOrgUser'] = false;

			const idx2 = MiscTools.findIndexGeneric(this.users, 'email', item.email.trim().toLowerCase());
			if (idx2 !== -1) {
				item['__portalUser'] = this.users[idx2];
				if (this.users[idx2].org_id && this.users[idx2].org_id !== 0) {
					if (idx !== -1 && this.users[idx2].org_id !== this.zenCustomers[idx].zcp_org_id) {
						item['__diffOrgUser'] = true;
					} // if
				} else {
					item['__noOrgUser'] = true;
				} // if

				item['__notificatioState'] = ValidationTools.getZenUserNotificationState(this.users, zenOrgIDs, item);
			} else {
				item['__portalUser'] = null;
				item['__notificatioState'] = 'No ZCP Account';
			} // if

			item['__supportShort'] = ValidationTools.getZenUserSupportLabel(item, true);
			item['__supportLong'] = ValidationTools.getZenUserSupportLabel(item, false);
		} // for

		this.loading = false;

		await MiscTools.delay(100);
		if (this.zenUsersTable)
			this.zenUsersTable.updateContent(this.items, this.storageKey, { showSite: true });

	}
}

